
export default class {

    static addPolicy(changes) {
        const fld = changes.field
        const row = changes.row
        const col = changes.collection
        const val = changes.value
        let pol, rowName


        // Applicants...
        if(fld == 'clients_count')
            pol = 'Purchase Property'


        if(col == 'existing_properties') {
            rowName = row.description
            pol = 'Existing Property'
        }
        
        // Income...

        if(col == 'clients') {
            rowName = row.first_name + ' Income'
            if(fld == 'employment_type') {
                if(val == 'Permanent Full Time')
                    pol = 'Permanent Full Time'
                if(val == 'Permanent Part Time')
                    pol = 'Permanent Part Time'
                if(val == 'Casual')
                    pol = 'Casual Income'
            }
        }

        // Loan purpose section...
                
        if(fld == 'purchase_property_exists')
            pol = 'Purchase Property'
        if(fld == 'construction_exists')
            pol = 'Construction'


        // Other income section...
                
        if(fld == 'family_payments_exists')
            pol = 'Family Payments'
        if(fld == 'child_support_exists')
            pol = 'Child Support'
        if(fld == 'government_payments_exists')
            pol = 'Government Pension'
        if(fld == 'investment_income_exists')
            pol = 'Investment Income'


        // Personal Loans...

        if(col == 'personal_loans') {
            rowName = row.description
            const intention = row.personal_loan_intention
            if(intention == 'keep')
                pol = 'Personal/Car Loans Keeping'
            else if(intention == 'refinance')
                pol = 'Personal/Car Loans Refinancing'
            else if(intention == 'close')
                pol = 'Personal/Car Loans Closing'
        }

        // Credit Cards...

        if(col == 'cards') {
            rowName = row.description
            const intention = row.card_intention
            if(intention == 'keep')
                pol = 'Credit Cards Keeping'
            else if(intention == 'refinance')
                pol = 'Credit Cards Refinancing'
            else if(intention == 'close')
                pol = 'Credit Cards Closing'
        }

        // More specifics section...
        
        if(fld == 'mature')
            pol = 'Superannuation'
        if(fld == 'bad_credit')
            pol = 'Adverse Credit'
        if(fld == 'previous_companies')
            pol = 'Company Not Trading'
        if(fld == 'separating')
            pol = 'Separation'
        if(fld == 'paying_child_support')
            pol = 'Paying Child Support'
        if(fld == 'mature')
            pol = 'Superannuation'


        // Mark up changes...

        if(pol) {
            changes.policy = pol
            console.log('### Policy from getRules is', pol)
        }
        else
            console.log('### No pol for changes ', changes)

        if(rowName)
            changes.rowName = rowName

    }
}


// WEBPACK FOOTER //
// ./src/dc/ChecklistRules.js